import { ActionTypes, LogoutAction, RedirectAction, SetAuthenticationMicrosoft, SetRolesAction } from './types';
import api from 'api';
import Cookies from 'universal-cookie';
const cookie = new Cookies();

export const logout = (callback?: () => {}): LogoutAction => {
  localStorage.removeItem('user');
  if (callback) {
    callback();
  }
  return {
    type: ActionTypes.LOGOUT,
  };
};

export const removeCookies = () => {
  cookie.remove('user', { domain: process.env.REACT_APP_DOMAIN });
  if (cookie.get('user') !== undefined)
    cookie.set('user', cookie.get('user'), { domain: process.env.REACT_APP_DOMAIN, expires: new Date() ,path:'/'})
}

export const redirect = (user: any): RedirectAction => ({
  type: ActionTypes.REDIRECT,
  user,
});

export const setRoles = (roles: string[]): SetRolesAction => ({
  type: ActionTypes.SET_ROLES,
  roles,
});

export const fetchCurrentUserRoles = () => async (dispatch: any) => {
  try {
    const currentUser = await api.getCurrentUser();
    dispatch(setRoles(currentUser.roles));
    const stored = JSON.parse(localStorage.getItem('user') || '{}');
    stored.roles = currentUser.roles;
    localStorage.setItem('user', JSON.stringify(stored));
  } catch {
    // roles will fall back to empty array
  }
};

export const setAuthenticationMicrosoft = (authenticated: boolean): SetAuthenticationMicrosoft => ({
  type: ActionTypes.AUTHENTICATION_MICROSOFT,
  authenticated,
});


